import { createAsyncThunk } from "@reduxjs/toolkit";

import { requestObsPipelineConfig } from "Api/observability/pipeline/requestObsPipelineConfig";
import logger from "Libs/logger";

import { ObservabilityPipelineProjectConfiguration } from "../types";

import type { AsyncThunkOptionType } from "Reducers/types";

export const loadObservabilityPipelineConfiguration = createAsyncThunk<
  ObservabilityPipelineProjectConfiguration | undefined,
  { projectId: string; environmentId: string },
  AsyncThunkOptionType
>(
  "app/observability_pipeline/configuration",
  async ({ projectId, environmentId }, { rejectWithValue }) => {
    try {
      return await requestObsPipelineConfig(projectId, environmentId);
    } catch (err) {
      if (!(typeof err === "string" && err.includes("html"))) {
        //Dont log unhandled errors from the server
        logger(err, {
          action: "app/observability_pipeline/configuration"
        });
      }
      return rejectWithValue(err);
    }
  }
);
